import { ReactNode } from 'react';
import {
  ChartTooltipStoreProvider,
  createChartTooltipStore,
} from '../hooks/useChartTooltipStore';

export function ChartTooltipWrapperProvider({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <ChartTooltipStoreProvider createStore={createChartTooltipStore}>
      {children}
    </ChartTooltipStoreProvider>
  );
}
